module.exports = __webpack_public_path__ + "static/media/Step-1.252c2db5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/How it works/Step-1.jpg
// module id = 297
// module chunks = 0